import type { FloorKind } from '@/gfx/tiles';
import type { ItemKind } from './items';

export type ImpactMaterial = 'metal' | 'glass' | 'soft';

/** A heavy tool on stone carries much farther than paper or a careful placement. */
export function dropSound(kind: ItemKind, floor: FloorKind, careful: boolean): { radius: number; material: ImpactMaterial } {
  const metal = kind === 'crowbar' || kind === 'battery' || kind === 'fuse' || kind.startsWith('key_');
  const glass = kind === 'bottle' || kind === 'camera';
  const base = kind === 'crowbar' ? 280 : kind === 'bottle' ? 180 : kind === 'camera' ? 150 : metal ? 110 : kind === 'firecracker' ? 45 : 8;
  const surface = floor.startsWith('carpet') ? 0.5 : ['stone', 'marble', 'checker', 'brick'].includes(floor) ? 1.15 : 1;
  return { radius: Math.round(base * surface * (careful ? 0.12 : 1)), material: metal ? 'metal' : glass ? 'glass' : 'soft' };
}

export function footstepSurface(floor: FloorKind): number {
  return floor.startsWith('carpet') ? 0.65 : ['stone', 'marble', 'checker'].includes(floor) ? 1.1 : 1;
}
